import React from 'react';

import { Divider, Flex, Text } from '@opendoor/bricks/core';

import { experiencePartnerDataProps } from '../../helpers/getAllLeadData';

interface ExperiencePartnerInfoProps {
  experiencePartner?: experiencePartnerDataProps;
}

export const ExperiencePartnerInfo: React.FC<ExperiencePartnerInfoProps> = ({
  experiencePartner,
}) => {
  return (
    <Flex flexDirection="column" fontSize="s2">
      <Divider />
      <Text fontWeight="semibold">Experience partner contact info:</Text>
      <Text>{experiencePartner?.name}</Text>
      <Text>{experiencePartner?.email}</Text>
    </Flex>
  );
};
